import { render } from "./AssignmentGrade.vue?vue&type=template&id=331202e8&scoped=true"
import script from "./AssignmentGrade.vue?vue&type=script&lang=js"
export * from "./AssignmentGrade.vue?vue&type=script&lang=js"

import "./AssignmentGrade.vue?vue&type=style&index=0&id=331202e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-331202e8"]])

export default __exports__